{
  "checklocations": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "orgDetail": [
        {
          "orgNo": "01",
          "orgName": "敦南中心",
          "orgAddress": "台北市大安區敦化南路二段333號2樓",
          "orgParking": "",
          "orgTransport": "捷運文湖線・六張犁站"
        },
        {
          "orgNo": "02",
          "orgName": "內湖中心",
          "orgAddress": "台北市內湖區瑞光路258巷35號6樓",
          "orgParking": "",
          "orgTransport": "捷運文湖線・港墘站"
        },
        {
          "orgNo": "04",
          "orgName": "新竹中心",
          "orgAddress": "新竹市北區經國路1898號3樓",
          "orgParking": "有停車場",
          "orgTransport": ""
        },
        {
          "orgNo": "05",
          "orgName": "台南中心",
          "orgAddress": "台南市中西區永福路一段185號2樓",
          "orgParking": "有停車場",
          "orgTransport": ""
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "questionnairefields": {
    "success": true,
    "statusCode": "S0000",
    "data": [
      {
        "questionnaireType": "個人病史",
        "questionnaireTypeXCode": "personalhistory",
        "diseaseGroups": [
          {
            "diseaseType": "慢性疾病及癌症",
            "diseaseTypeCode": "chronic_cancer",
            "diseaseOptions": [
              {
                "name": "高血壓",
                "code": "hypertension"
              },
              {
                "name": "糖尿病",
                "code": "diabetes"
              },
              {
                "name": "高血脂",
                "code": "hyperlipidemia"
              },
              {
                "name": "癌症",
                "code": "cancer"
              },
              {
                "name": "乳癌",
                "code": "breast_cancer"
              },
              {
                "name": "肺癌",
                "code": "lung_cancer"
              },
              {
                "name": "腸/大腸癌",
                "code": "colorectal_cancer"
              },
              {
                "name": "卵巢/子宮癌",
                "code": "ovarian_uterine_cancer"
              }
            ]
          },
          {
            "diseaseType": "血管/神經性相關疾病",
            "diseaseTypeCode": "vascular_neuro",
            "diseaseOptions": [
              {
                "name": "心血管疾病",
                "code": "cardiovascular"
              },
              {
                "name": "腦血管疾病",
                "code": "cerebrovascular"
              },
              {
                "name": "失智症",
                "code": "dementia"
              }
            ]
          },
          {
            "diseaseType": "全身性/免疫疾病",
            "diseaseTypeCode": "systemic_immune",
            "diseaseOptions": [
              {
                "name": "自體免疫疾病",
                "code": "autoimmune"
              },
              {
                "name": "甲狀腺疾病",
                "code": "thyroid"
              },
              {
                "name": "貧血",
                "code": "anemia"
              },
              {
                "name": "白血病",
                "code": "leukemia"
              }
            ]
          },
          {
            "diseaseType": "肝膽腸胃相關疾病",
            "diseaseTypeCode": "digestive_renal",
            "diseaseOptions": [
              {
                "name": "慢性肝炎或肝硬化",
                "code": "chronic_hepatitis"
              },
              {
                "name": "腎臟疾病",
                "code": "kidney_disease"
              }
            ]
          },
          {
            "diseaseType": "若您有其他疾病，可直接輸入",
            "diseaseTypeCode": "other",
            "diseaseOptions": []
          }
        ]
      },
      {
        "questionnaireType": "家族病史",
        "questionnaireTypeXCode": "familyhistory",
        "diseaseGroups": [
          {
            "diseaseType": "慢性疾病及癌症",
            "diseaseTypeCode": "chronic_cancer",
            "diseaseOptions": [
              {
                "name": "高血壓",
                "code": "hypertension"
              },
              {
                "name": "糖尿病",
                "code": "diabetes"
              },
              {
                "name": "高血脂",
                "code": "hyperlipidemia"
              },
              {
                "name": "癌症",
                "code": "cancer"
              }
            ]
          },
          {
            "diseaseType": "全身性/免疫疾病",
            "diseaseTypeCode": "systemic_immune",
            "diseaseOptions": [
              {
                "name": "癲癇",
                "code": "epilepsy"
              },
              {
                "name": "過敏",
                "code": "allergy"
              },
              {
                "name": "甲狀腺疾病",
                "code": "thyroid_disease"
              },
              {
                "name": "貧血",
                "code": "anemia"
              },
              {
                "name": "中風",
                "code": "stroke"
              }
            ]
          },
          {
            "diseaseType": "眼耳相關疾病",
            "diseaseTypeCode": "eye_ear_disease",
            "diseaseOptions": [
              {
                "name": "白內障",
                "code": "cataract"
              },
              {
                "name": "青光眼",
                "code": "glaucoma"
              },
              {
                "name": "黃斑部病變",
                "code": "macular_degeneration"
              },
              {
                "name": "中耳炎",
                "code": "otitis_media"
              },
              {
                "name": "聽力障礙",
                "code": "hearing_loss"
              }
            ]
          },
          {
            "diseaseType": "心血管相關疾病",
            "diseaseTypeCode": "cardiovascular_disease",
            "diseaseOptions": [
              {
                "name": "心臟病",
                "code": "heart_disease"
              },
              {
                "name": "中風",
                "code": "stroke"
              },
              {
                "name": "慢性氣管炎",
                "code": "chronic_asthma"
              },
              {
                "name": "肺氣腫",
                "code": "emphysema"
              },
              {
                "name": "肺結核",
                "code": "tuberculosis"
              }
            ]
          },
          {
            "diseaseType": "肝膽腸胃相關疾病",
            "diseaseTypeCode": "digestive_disease",
            "diseaseOptions": [
              {
                "name": "肝病",
                "code": "liver_disease"
              },
              {
                "name": "脂肪肝",
                "code": "fatty_liver"
              },
              {
                "name": "逆流性食道炎",
                "code": "gerd"
              },
              {
                "name": "消化性潰瘍",
                "code": "peptic_ulcer"
              },
              {
                "name": "胃炎",
                "code": "gastritis"
              }
            ]
          },
          {
            "diseaseType": "外傷相關疾病",
            "diseaseTypeCode": "trauma_disease",
            "diseaseOptions": [
              {
                "name": "骨折",
                "code": "fracture"
              }
            ]
          },
          {
            "diseaseType": "若您有其他疾病，可直接輸入",
            "diseaseTypeCode": "other",
            "diseaseOptions": []
          }
        ]
      },
      {
        "questionnaireType": "自覺症狀",
        "questionnaireTypeXCode": "subjective_symptoms",
        "diseaseGroups": [
          {
            "diseaseType": "頭部",
            "diseaseTypeCode": "head",
            "diseaseOptions": [
              {
                "name": "頭暈",
                "code": "dizziness"
              },
              {
                "name": "頭痛",
                "code": "headache"
              },
              {
                "name": "視力模糊",
                "code": "blurred_vision"
              },
              {
                "name": "咳嗽",
                "code": "cough"
              },
              {
                "name": "咳痰",
                "code": "phlegm"
              },
              {
                "name": "牙齦出血",
                "code": "gum_bleeding"
              },
              {
                "name": "耳鳴",
                "code": "tinnitus"
              },
              {
                "name": "呼吸困難",
                "code": "dyspnea"
              },
              {
                "name": "悶心",
                "code": "chest_tightness"
              }
            ]
          },
          {
            "diseaseType": "胸腹",
            "diseaseTypeCode": "chest_abdomen",
            "diseaseOptions": [
              {
                "name": "胸痛",
                "code": "chest_pain"
              },
              {
                "name": "心悸",
                "code": "palpitations"
              },
              {
                "name": "腹痛",
                "code": "abdominal_pain"
              },
              {
                "name": "胃灼熱",
                "code": "heartburn"
              },
              {
                "name": "脹氣",
                "code": "bloating"
              },
              {
                "name": "黑便",
                "code": "melena"
              },
              {
                "name": "血便",
                "code": "bloody_stool"
              },
              {
                "name": "腹瀉",
                "code": "diarrhea"
              },
              {
                "name": "便祕",
                "code": "constipation"
              }
            ]
          },
          {
            "diseaseType": "四肢",
            "diseaseTypeCode": "limbs",
            "diseaseOptions": [
              {
                "name": "上肢痛",
                "code": "upper_limb_pain"
              },
              {
                "name": "下肢痛",
                "code": "lower_limb_pain"
              },
              {
                "name": "關節疼痛",
                "code": "joint_pain"
              },
              {
                "name": "手腳麻痛",
                "code": "numbness_tingling"
              },
              {
                "name": "手腳肌肉無力",
                "code": "muscle_weakness"
              }
            ]
          },
          {
            "diseaseType": "特殊症狀",
            "diseaseTypeCode": "special_symptoms",
            "diseaseOptions": [
              {
                "name": "其他",
                "code": "other"
              },
              {
                "name": "體重減輕3公斤以上",
                "code": "weight_loss_over_3kg"
              },
              {
                "name": "排尿不適",
                "code": "urination_discomfort"
              },
              {
                "name": "多尿、頻尿",
                "code": "polyuria_frequency"
              }
            ]
          },
          {
            "diseaseType": "其他症狀",
            "diseaseTypeCode": "other_symptoms",
            "diseaseOptions": []
          }
        ]
      }
    ],
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "userplanresult": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "riskItems": [
        "血管健康",
        "代謝功能",
        "消化道狀況"
      ],
      "allCheckup": {
        "price": "75300",
        "abnormalCnt": "26",
        "potentialCnt": "2",
        "standardCnt": "51",
        "packageList": [
          {
            "deptName": "心血管及代謝系統",
            "deptEName": "Cardiovascular and Metabolic System",
            "examItemList": [
              {
                "examName": "十年心血管疾病風險評估",
                "examItem": "R401470005",
                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              },
              {
                "examName": "同半胱氨酸",
                "examItem": "R401470006",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              },
              {
                "examName": "心肌旋轉蛋白",
                "examItem": "R401470007",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              },
              {
                "examName": "甲狀腺球蛋白",
                "examItem": "R401470008",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examType": "潛在疾病風險檢查建議",
                "examPrice": "1000",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "眼科檢查",
            "deptEName": "Eye Examination",
            "examItemList": [
              {
                "examName": "眼底斷層掃描",
                "examItem": "PE000001A",
                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "一般檢查",
            "deptEName": "General Examination",
            "examItemList": [
              {
                "examName": "體脂肪率",
                "examItem": "PE00010019",
                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "身體質量指數",
                "examItem": "PE00010006",
                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "腰圍",
                "examItem": "PE00010017",
                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "血壓",
                "examItem": "PE00010009A",
                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "影像醫學",
            "deptEName": "Image Examination",
            "examItemList": [
              {
                "examName": "骨盆腔核磁共振",
                "examItem": "PE000001C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "腰薦椎磁振造影",
                "examItem": "PE000002C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "腦部&腦頸動脈磁振造影",
                "examItem": "PE000003C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "上腹部核磁共振",
                "examItem": "PE000004C",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": " 感染及其他",
            "deptEName": "Infections And Other",
            "examItemList": [
              {
                "examName": "麻醉(套檢)",
                "examItem": "PE001000",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "大腸鏡(切片)",
                "examItem": "LB000401K",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          }
        ]
      },
      "aiExclusive": {
        "price": "15300",
        "abnormalCnt": "22",
        "potentialCnt": "2",
        "standardCnt": "51",
        "packageList": [
          {
            "deptName": "心血管及代謝系統",
            "deptEName": "Cardiovascular and Metabolic System",
            "examItemList": [
              {
                "examName": "十年心血管疾病風險評估",
                "examItem": "R401470005",
                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                "examPrice": "3000",
                "examType": "潛在疾病風險檢查建議",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "眼科檢查",
            "deptEName": "Eye Examination",
            "examItemList": [
              {
                "examName": "眼底斷層掃描",
                "examItem": "PE000001A",
                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                "examPrice": "4000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "一般檢查",
            "deptEName": "General Examination",
            "examItemList": [
              {
                "examName": "體脂肪率",
                "examItem": "PE00010019",
                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "身體質量指數",
                "examItem": "PE00010006",
                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "腰圍",
                "examItem": "PE00010017",
                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "血壓",
                "examItem": "PE00010009A",
                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              }
            ]
          },
          {
            "deptName": "感染及其他",
            "deptEName": "Infections And Other",
            "examItemList": [
              {
                "examName": "麻醉(套檢)",
                "examItem": "PE001000",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              },
              {
                "examName": "大腸鏡(切片)",
                "examItem": "LB000401K",
                "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
                "examPrice": "2000",
                "examType": "個人歷史異常追蹤",
                "isChecked": true
              }
            ]
          }
        ]
      },
      "basicCheckup": {
        "price": "8500",
        "abnormalCnt": "0",
        "potentialCnt": "0",
        "standardCnt": "51",
        "packageList": [
          {
            "deptName": "一般檢查",
            "deptEName": "General Examination",
            "examItemList": [
              {
                "examName": "體脂肪率",
                "examItem": "PE00010019",
                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "身體質量指數",
                "examItem": "PE00010006",
                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "腰圍",
                "examItem": "PE00010017",
                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              },
              {
                "examName": "血壓",
                "examItem": "PE00010009A",
                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                "examPrice": "3000",
                "examType": "優先必要檢查項目",
                "isChecked": true
              }
            ]
          }
        ]
      }
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "checksuggestionsbundle": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "abnormalDetail": [
        {
          "deptName": "消化系統",
          "deptEName": "Digestive System",
          "examInfos": [
            {
              "examName": "胃蛋白酶原",
              "examItem": "L004400A",
              "examMemo": "胃蛋白酶原是評估胃黏膜分泌功能，異常可能暗示胃潰瘍或胃癌風險。檢查胃蛋白酶原有助於早期發現胃部疾病。",
              "price": "3000",
              "mutexInfos": [
                "L2001900"
              ]
            },
            {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "price": "3500",
              "mutexInfos": [
                "L004400A"
              ]
            }
          ]
        }
      ],
      "potentialDetail": [
        {
          "deptName": "心血管及代謝系統",
          "deptEName": "Cardiovascular and Metabolic System",
          "examInfos": [
            {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "price": "1200",
              "mutexInfos": []
            },
            {
              "examName": "運動心電圖",
              "examItem": "L1001200A",
              "examMemo": "運動心電圖檢查可評估心臟在運動狀態下血壓與心電圖的變化，評估心臟是否有缺氧、心絞痛或心律不整的情形。",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        }
      ],
      "bodyInsightDetail": [
        {
          "deptName": "眼科檢查",
          "deptEName": "Eye Examination",
          "examInfos": [
            {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "price": "1200",
              "mutexInfos": [
                "PE000001A",
                "R2027000A"
              ]
            },
            {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        }
      ],
      "addExamDetail": [
        {
          "deptName": "熱門檢項",
          "deptEName": "Trending Examination",
          "examInfos": [
            {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "price": "300",
              "mutexInfos": []
            },
            {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "price": "500",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "一般檢查",
          "deptEName": "General Examination",
          "examInfos": [
            {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "price": "300",
              "mutexInfos": []
            },
            {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "price": "500",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "腫瘤標記",
          "deptEName": "Tumor Biomarker",
          "examInfos": [
            {
              "examName": "前列腺特異抗原",
              "examItem": "LI004600",
              "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
              "examType": "",
              "price": "1500",
              "mutexInfos": []
            },
            {
              "examName": "腫瘤組織多胜脢抗原",
              "examItem": "LI005600",
              "examMemo": "腫瘤組織多胜脢抗原（TPA）是上皮細胞腫瘤的標記。",
              "examType": "",
              "price": "1800",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "心血管及代謝系統",
          "deptEName": "Cardiovascular and Metabolic System",
          "examInfos": [
            {
              "examName": "甲狀腺球蛋白",
              "examItem": "R401470008",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            },
            {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            },
            {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "",
              "price": "1200",
              "mutexInfos": []
            },
            {
              "examName": "運動心電圖",
              "examItem": "L1001200A",
              "examMemo": "運動心電圖檢查可評估心臟在運動狀態下血壓與心電圖的變化，評估心臟是否有缺氧、心絞痛或心律不整的情形。",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "眼科檢查",
          "deptEName": "Eye Examination",
          "examInfos": [
            {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "",
              "price": "1200",
              "mutexInfos": [
                "PE000001A",
                "R2027000A"
              ]
            },
            {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "",
              "price": "1000",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "影像醫學",
          "deptEName": "Image Examination",
          "examInfos": [
            {
              "examName": "骨盆腔核磁共振",
              "examItem": "PE000001C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            },
            {
              "examName": "腰薦椎磁振造影",
              "examItem": "PE000002C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            },
            {
              "examName": "腦部&腦頸動脈磁振造影",
              "examItem": "PE000003C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            },
            {
              "examName": "上腹部核磁共振",
              "examItem": "PE000004C",
              "examMemo": "推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦原因推薦",
              "examType": "",
              "price": "2000",
              "mutexInfos": []
            }
          ]
        },
        {
          "deptName": "消化系統",
          "deptEName": "Digestive System",
          "examInfos": [
            {
              "examName": "胃蛋白酶原",
              "examItem": "L004400A",
              "examMemo": "胃蛋白酶原是評估胃黏膜分泌功能，異常可能暗示胃潰瘍或胃癌風險。檢查胃蛋白酶原有助於早期發現胃部疾病。",
              "examType": "",
              "price": "3000",
              "mutexInfos": [
                "L2001900"
              ]
            },
            {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "",
              "price": "3500",
              "mutexInfos": [
                "L004400A"
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-05-07T09:00:00Z"
  },
  "eligibilityquestionnairefields": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "indicationInfos": [
        {
          "questionnaireTypeId": "GI01",
          "questionnaireTypeName": "麻醉",
          "examItem": "PE001000",
          "questionList": [
            {
              "questionId": "001",
              "questionName": "目前已懷孕、可能懷孕，或正在進行生殖醫療",
              "choiceList": [
                {
                  "choiceId": 2,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 3,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            },
            {
              "questionId": "002",
              "questionName": "有癲癇病史或目前有癲癇發作",
              "choiceList": [
                {
                  "choiceId": 4,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 5,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            },
            {
              "questionId": "003",
              "questionName": "最近有鼻塞或痰多現象",
              "choiceList": [
                {
                  "choiceId": 6,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 7,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            }
          ]
        },
        {
          "questionnaireTypeId": "GI02",
          "questionnaireTypeName": "胃鏡、大腸鏡(切片)",
          "examItem": "LB000401K",
          "questionList": [
            {
              "questionId": "004",
              "questionName": "您的 BMI 是否 >= 34",
              "choiceList": [
                {
                  "choiceId": 8,
                  "choiceResult": "Y",
                  "isContinue": false
                },
                {
                  "choiceId": 9,
                  "choiceResult": "N",
                  "isContinue": true
                }
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-05-12T13:00:00Z"
  },
  "checkreminders": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "reminderList": [
        {
          "examNameList": [
            "大腸鏡"
          ],
          "reminderText": "<ol><li>已知使用保健品，〖魚油、銀杏、紅麴、納豆激酶、人參〗或中藥需停 7 日</li><li>已知如檢查當下發現瘜肉：<ol class='alphabet-list'><li>醫師會評估大小和出血風險高低。</li><li>判斷是否可進行切片或切除術處置，處置瘜肉將送化驗，化驗費用另計。</li><li>如出現無法處置狀況或超過 0.8 公分以上瘜肉，則現場不做切片或切除處置</li></ol></li><li>已知檢查當日切除術者，健檢完兩週內不可搭飛機、不可做核磁共振相關檢查</li><li>已知抽血檢驗:血小板數值須大於 10 萬才能執行切片或切除檢驗</li></ol>"
        },
        {
          "examNameList": [
            "腦部磁振造影",
            "頸部磁振造影"
          ],
          "reminderText": "檢查前三天請勿安排上消化道攝影檢查，避免影響檢查。"
        },
        {
          "examNameList": [
            "水痘抗體IgG"
          ],
          "reminderText": "<ol><li>若得過水痘、帶狀皰疹病史檢查當天請告知現場人員</li><li>若有接種疫苗至少應間隔 4 週後再檢查</li></ol>"
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "checkupsettings": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "languInfos": [
        {
          "uno": "1",
          "noDesc": "中文"
        },
        {
          "uno": "2",
          "noDesc": "英文"
        },
        {
          "uno": "3",
          "noDesc": "日文"
        }
      ],
      "breakfastInfos": [
        {
          "uno": "01",
          "noDesc": "中式/素食"
        },
        {
          "uno": "02",
          "noDesc": "中式/葷食"
        },
        {
          "uno": "03",
          "noDesc": "西式/素食"
        },
        {
          "id": "04",
          "noDesc": "西式/葷食"
        }
      ],
      "lunchInfos": [
        {
          "uno": "01",
          "noDesc": "中式/素食"
        },
        {
          "uno": "02",
          "noDesc": "中式/葷食"
        },
        {
          "uno": "03",
          "noDesc": "西式/素食"
        },
        {
          "uno": "04",
          "noDesc": "西式/葷食"
        }
      ],
      "sizeInfos": [
        {
          "uno": "01",
          "noDesc": "M"
        },
        {
          "uno": "02",
          "noDesc": "L"
        },
        {
          "uno": "03",
          "noDesc": "XL"
        },
        {
          "uno": "04",
          "noDesc": "2L"
        },
        {
          "uno": "05",
          "noDesc": "3L"
        },
        {
          "uno": "06",
          "noDesc": "4L"
        },
        {
          "uno": "07",
          "noDesc": "5L"
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "availabledates": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "dayType": "2",
      "bookCalInfos": [
        {
          "bookCnt": "10",
          "bookDate": "20250715",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "1",
          "bookDate": "20250716",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "30",
          "bookDate": "20250717",
          "bookTimes": [
            "0730",
            "0815",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "27",
          "bookDate": "20250718",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "0",
          "bookDate": "20250719",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "2",
          "bookDate": "20250720",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "3",
          "bookDate": "20250721",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250722",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "1",
          "bookDate": "20250723",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "30",
          "bookDate": "20250724",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250725",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250726",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1300"
          ]
        }
      ],
      "nutCalInfos": [
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250715",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250716",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 1,
          "nutBookDate": "20250717",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 30,
          "nutBookDate": "20250718",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250719",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1500"
          ]
        },
        {
          "nutBookCnt": 1,
          "nutBookDate": "20250720",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1500"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250721",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250722",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250723",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250724",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100",
            "1600"
          ]
        }
      ],
      "imageCalInfos": true
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "confirmappointment": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "caseNo": "250016232"
    },
    "timestamp": "2025-05-13T13:10:00Z"
  },
  "calendar": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "reminders": [
        {
          "date": "2025/04/01",
          "description": [
            "開始每日攝取足夠的水分，至少1,500~2,000c.c."
          ]
        },
        {
          "date": "2025/04/18",
          "description": [
            "服用清腸藥之前可留取糞便檢體，檢體放冰箱冷藏，冷藏不超過2天",
            "女性若遇生理期，請勿留取檢體"
          ]
        },
        {
          "date": "2025/04/21",
          "description": [
            "低渣飲食開始（不可食用蔬菜、水果和乳製品；若非每日排便，請提前於檢查前 5~6天 低渣）"
          ]
        },
        {
          "date": "2025/04/21",
          "description": [
            "檢查前需空腹至少8小時，女性收集檢體與當日檢查請避開生理期間，若遇生理期，可前往健檢、或於預約紀錄修改健檢日期",
            "報到時請主動告知是否懷孕或備孕，過敏史及用藥情況",
            "報到請準備：<br/>a. 健保卡／身分證或居留證<br/>b. 已完成資料袋內之文件"
          ]
        }
      ]
    },
    "timestamp": "2025-04-27T13:20:00Z"
  },
  "enterpriseplans": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "companyInfo": {
        "companyNo": "50093",
        "companyName": "台灣漢高股份有限公司",
        "bookableDateE": "20250515",
        "sponsorAmt": "2000"
      },
      "packageList": [
        {
          "packageNo": "500930046",
          "packageName": "健康樂活＋心血管＋消化道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "6600.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "潛在疾病風險建議",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010004",
                  "examName": "身體組成分析",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010018",
                  "examName": "糖尿病",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010002",
                  "examName": "高血壓",
                  "examMemo": "了解身體基本資料"
                },
                {
                  "examItem": "PE00010005",
                  "examName": "高血脂",
                  "examMemo": "了解身體基本資料"
                }
              ]
            },
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010003",
                  "examName": "理想體重",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010001",
                  "examName": "身高",
                  "examMemo": "了解身體基本資料"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            }
          ]
        },
        {
          "packageNo": "500930047",
          "packageName": "健康樂活＋心血管＋消化道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "5500.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010003",
                  "examName": "理想體重",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            },
            {
              "groupTitleName": "3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R4014700A",
                  "examName": "頸動脈超音波",
                  "examMemo": "評估供應腦部血流的頸動脈有無硬化、狹窄等異常"
                },
                {
                  "examItem": "LI005500",
                  "examName": "CA 72-4腫瘤標記",
                  "examMemo": "胃癌篩檢參考指標"
                },
                {
                  "examItem": "L1008000A",
                  "examName": "HRV自律神經",
                  "examMemo": "檢查交感、副交感神經的調控是否異常，了解自律神經的年齡、功能指標及平衡程度，並評估您的情緒、壓力指數"
                }
              ]
            }
          ],
          "groupChooseList": [
            {
              "groupTitleName": "組合 3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "groupList": [
                {
                  "examItemList": [
                    {
                      "examItem": "LI003800",
                      "examName": "CA125腫瘤標記",
                      "examMemo": "女性生殖器癌（如卵巢癌）篩檢參考指標"
                    },
                    {
                      "examItem": "LO010500B",
                      "examName": "(組合)子宮頸抹片檢查(企業)含內診",
                      "examMemo": "篩檢子宮頸細胞有無病變(含內診檢查)"
                    },
                    {
                      "examItem": "T8001000A",
                      "examName": "婦科超音波",
                      "examMemo": "檢查有無子宮或卵巢腫瘤等結構異常"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R1020300A",
                      "examName": "腹部X光及腰薦椎側面X光",
                      "examMemo": "有無腸阻塞、膽結石、泌尿系統結石,評估腰椎、骨盆、髖關節疾病"
                    },
                    {
                      "examItem": "R1140400A",
                      "examName": "左髖關節骨質密度",
                      "examMemo": "瞭解骨質狀況，有無骨質減少或疏鬆情形"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R2030100A",
                      "examName": "乳房超音波",
                      "examMemo": "利用超音波檢查乳房是否異常"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "packageNo": "500930048",
          "packageName": "健康樂活＋心血管＋消化道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "15000.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010001",
                  "examName": "身高",
                  "examMemo": "了解身體基本資料"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            },
            {
              "groupTitleName": "3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R4014700A",
                  "examName": "頸動脈超音波",
                  "examMemo": "評估供應腦部血流的頸動脈有無硬化、狹窄等異常"
                },
                {
                  "examItem": "LI005500",
                  "examName": "CA 72-4腫瘤標記",
                  "examMemo": "胃癌篩檢參考指標"
                },
                {
                  "examItem": "L1008000A",
                  "examName": "HRV自律神經",
                  "examMemo": "檢查交感、副交感神經的調控是否異常，了解自律神經的年齡、功能指標及平衡程度，並評估您的情緒、壓力指數"
                }
              ]
            }
          ],
          "groupChooseList": [
            {
              "groupTitleName": "組合 3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "groupList": [
                {
                  "examItemList": [
                    {
                      "examItem": "LI003800",
                      "examName": "CA125腫瘤標記",
                      "examMemo": "女性生殖器癌（如卵巢癌）篩檢參考指標"
                    },
                    {
                      "examItem": "LO010500B",
                      "examName": "(組合)子宮頸抹片檢查(企業)含內診",
                      "examMemo": "篩檢子宮頸細胞有無病變(含內診檢查)"
                    },
                    {
                      "examItem": "T8001000A",
                      "examName": "婦科超音波",
                      "examMemo": "檢查有無子宮或卵巢腫瘤等結構異常"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R1020300A",
                      "examName": "腹部X光及腰薦椎側面X光",
                      "examMemo": "有無腸阻塞、膽結石、泌尿系統結石,評估腰椎、骨盆、髖關節疾病"
                    },
                    {
                      "examItem": "R1140400A",
                      "examName": "左髖關節骨質密度",
                      "examMemo": "瞭解骨質狀況，有無骨質減少或疏鬆情形"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R2030100A",
                      "examName": "乳房超音波",
                      "examMemo": "利用超音波檢查乳房是否異常"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "packageNo": "500930099",
          "packageName": "健康樂活＋心血管＋刃牙道",
          "dayType": "1",
          "bookPeriod": "1",
          "price": "8000.00000",
          "hasBreakfast": true,
          "hasLunch": false,
          "deptList": [
            {
              "deptName": "潛在疾病風險建議",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010004",
                  "examName": "身體組成分析",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010018",
                  "examName": "糖尿病",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010002",
                  "examName": "高血壓",
                  "examMemo": "了解身體基本資料"
                },
                {
                  "examItem": "PE00010005",
                  "examName": "高血脂",
                  "examMemo": "了解身體基本資料"
                }
              ]
            },
            {
              "deptName": "一般檢查",
              "deptEName": "General  Examination",
              "examItemList": [
                {
                  "examItem": "PE00010003",
                  "examName": "理想體重",
                  "examMemo": "利用身高與體重之比例推估個人之體重是否標準"
                },
                {
                  "examItem": "PE00010017",
                  "examName": "腰圍",
                  "examMemo": "了解身體基本資料 代謝症候群評估指標之一"
                },
                {
                  "examItem": "PE00010001",
                  "examName": "身高",
                  "examMemo": "了解身體基本資料"
                }
              ]
            }
          ],
          "examChooseList": [
            {
              "groupTitleName": "2 選 1",
              "groupCount": 2,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R1040300A",
                  "examName": "頸椎X光",
                  "examMemo": "檢查頸椎有無骨刺、滑脫、椎間狹窄等異常"
                },
                {
                  "examItem": "PE00040017B",
                  "examName": "眼科醫師檢查-不含眼壓",
                  "examMemo": "眼科醫師利用眼底鏡及細隙燈，進行眼球內部(包括角膜、前房、瞳孔、水晶體、視網膜、視神經)檢測"
                }
              ]
            },
            {
              "groupTitleName": "3 選 1",
              "groupCount": 3,
              "chooseCount": 1,
              "examItemList": [
                {
                  "examItem": "R4014700A",
                  "examName": "頸動脈超音波",
                  "examMemo": "評估供應腦部血流的頸動脈有無硬化、狹窄等異常"
                },
                {
                  "examItem": "LI005500",
                  "examName": "CA 72-4腫瘤標記",
                  "examMemo": "胃癌篩檢參考指標"
                },
                {
                  "examItem": "L1008000A",
                  "examName": "HRV自律神經",
                  "examMemo": "檢查交感、副交感神經的調控是否異常，了解自律神經的年齡、功能指標及平衡程度，並評估您的情緒、壓力指數"
                }
              ]
            }
          ],
          "groupChooseList": [
            {
              "groupTitleName": "組合 3 選 2",
              "groupCount": 3,
              "chooseCount": 2,
              "groupList": [
                {
                  "examItemList": [
                    {
                      "examItem": "LI00380U",
                      "examName": "賀爾蒙檢查",
                      "examMemo": "女性生殖器癌（如卵巢癌）篩檢參考指標"
                    },
                    {
                      "examItem": "LO010500B",
                      "examName": "(組合)子宮頸抹片檢查(企業)含內診",
                      "examMemo": "篩檢子宮頸細胞有無病變(含內診檢查)"
                    },
                    {
                      "examItem": "T8001000B",
                      "examName": "大腸鏡",
                      "examMemo": "檢查有無子宮或卵巢腫瘤等結構異常"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R1020300A",
                      "examName": "腹部X光及腰薦椎側面X光",
                      "examMemo": "有無腸阻塞、膽結石、泌尿系統結石,評估腰椎、骨盆、髖關節疾病"
                    },
                    {
                      "examItem": "R1140400A",
                      "examName": "左髖關節骨質密度",
                      "examMemo": "瞭解骨質狀況，有無骨質減少或疏鬆情形"
                    }
                  ]
                },
                {
                  "examItemList": [
                    {
                      "examItem": "R2030100A",
                      "examName": "乳房超音波",
                      "examMemo": "利用超音波檢查乳房是否異常"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "compareplans": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "packageDetail": [
        {
          "packageNo": "30145142",
          "packageInfo": [
            {
              "deptName": "一般檢查",
              "deptEName": "General Examination",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "身體組成分析",
                  "examItem": "PE00010040",
                  "isChecked": true
                },
                {
                  "examName": "身高",
                  "examItem": "PE00010001",
                  "isChecked": true
                },
                {
                  "examName": "體重",
                  "examItem": "PE00010002",
                  "isChecked": true
                },
                {
                  "examName": "身體質量指數",
                  "examItem": "PE00010006",
                  "isChecked": true
                },
                {
                  "examName": "理想體重",
                  "examItem": "PE00010003",
                  "isChecked": true
                },
                {
                  "examName": "脈搏",
                  "examItem": "PE00010007A",
                  "isChecked": true
                },
                {
                  "examName": "血壓",
                  "examItem": "PE00010009A",
                  "isChecked": true
                },
                {
                  "examName": "腰圍",
                  "examItem": "PE00010017",
                  "isChecked": true
                }
              ]
            },
            {
              "deptName": "心血管及代謝系統",
              "deptEName": "Cardiovascular and Metabolic System",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "總膽固醇",
                  "examItem": "L3001900",
                  "isChecked": true
                },
                {
                  "examName": "三酸甘油脂",
                  "examItem": "L3002000",
                  "isChecked": true
                }
              ]
            },
            {
              "deptName": "腫瘤標記",
              "deptEName": "Tumor Marker",
              "isGroup": true,
              "groupInfo": [
                {
                  "groupTitleName": "腫瘤二選一",
                  "chooseCnt": 1,
                  "groupList": [
                    {
                      "groupName": "CA199腫瘤標記",
                      "groupItem": "LI004100"
                    },
                    {
                      "groupName": "CA153腫瘤標記",
                      "groupItem": "LI004900"
                    }
                  ]
                },
                {
                  "groupTitleName": "腫瘤三選一",
                  "chooseCnt": 1,
                  "groupList": [
                    {
                      "groupName": "CA199腫瘤標記",
                      "groupItem": "LI004100"
                    },
                    {
                      "groupName": "CA153腫瘤標記",
                      "groupItem": "LI004900"
                    },
                    {
                      "groupName": "CA133腫瘤標記",
                      "groupItem": "LI004901"
                    }
                  ]
                }
              ],
              "examInfo": [
                {
                  "examName": "癌胚胎抗原",
                  "examItem": "LI001600",
                  "isChecked": true
                },
                {
                  "examName": "鱗狀細胞癌抗原",
                  "examItem": "LI005200",
                  "isChecked": true
                }
              ]
            }
          ]
        },
        {
          "packageNo": "30145567",
          "packageInfo": [
            {
              "deptName": "一般檢查",
              "deptEName": "General Examination",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "身體組成分析",
                  "examItem": "PE00010040",
                  "isChecked": true
                },
                {
                  "examName": "身高",
                  "examItem": "PE00010001",
                  "isChecked": true
                },
                {
                  "examName": "體重",
                  "examItem": "PE00010002",
                  "isChecked": true
                },
                {
                  "examName": "身體質量指數",
                  "examItem": "PE00010006",
                  "isChecked": false
                },
                {
                  "examName": "理想體重",
                  "examItem": "PE00010003",
                  "isChecked": true
                },
                {
                  "examName": "脈搏",
                  "examItem": "PE00010007A",
                  "isChecked": false
                },
                {
                  "examName": "血壓",
                  "examItem": "PE00010009A",
                  "isChecked": true
                },
                {
                  "examName": "腰圍",
                  "examItem": "PE00010017",
                  "isChecked": false
                }
              ]
            },
            {
              "deptName": "心血管及代謝系統",
              "deptEName": "Cardiovascular and Metabolic System",
              "isGroup": false,
              "groupInfo": [],
              "examInfo": [
                {
                  "examName": "總膽固醇",
                  "examItem": "L3001900",
                  "isChecked": true
                },
                {
                  "examName": "三酸甘油脂",
                  "examItem": "L3002000",
                  "isChecked": false
                }
              ]
            },
            {
              "deptName": "腫瘤標記",
              "deptEName": "Tumor Marker",
              "isGroup": true,
              "groupInfo": [
                {
                  "groupTitleName": "腫瘤二選一",
                  "chooseCnt": 1,
                  "groupList": [
                    {
                      "groupName": "CA199腫瘤標記",
                      "groupItem": "LI004100"
                    },
                    {
                      "groupName": "CA153腫瘤標記",
                      "groupItem": "LI004900"
                    }
                  ]
                }
              ],
              "examInfo": [
                {
                  "examName": "癌胚胎抗原",
                  "examItem": "LI001600",
                  "isChecked": true
                },
                {
                  "examName": "鱗狀細胞癌抗原",
                  "examItem": "LI005200",
                  "isChecked": true
                }
              ]
            }
          ]
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "enterprisecheckupsettings": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "language": [
        {
          "id": "1",
          "name": "繁體中文"
        },
        {
          "id": "2",
          "name": "英文"
        },
        {
          "id": "3",
          "name": "日文"
        }
      ],
      "breakfast": [
        {
          "id": "01",
          "name": "中式/素食"
        },
        {
          "id": "02",
          "name": "中式/葷食"
        },
        {
          "id": "03",
          "name": "西式/素食"
        },
        {
          "id": "04",
          "name": "西式/葷食"
        }
      ],
      "lunch": [
        {
          "id": "01",
          "name": "中式/素食"
        },
        {
          "id": "02",
          "name": "中式/葷食"
        },
        {
          "id": "03",
          "name": "西式/素食"
        },
        {
          "id": "04",
          "name": "西式/葷食"
        }
      ],
      "clothesSize": [
        {
          "id": "01",
          "name": "M"
        },
        {
          "id": "02",
          "name": "L"
        },
        {
          "id": "03",
          "name": "XL"
        },
        {
          "id": "04",
          "name": "2L"
        },
        {
          "id": "05",
          "name": "3L"
        },
        {
          "id": "06",
          "name": "4L"
        },
        {
          "id": "07",
          "name": "5L"
        }
      ],
      "isContactPickupByAgent": true,
      "isDeliveryPickupByAgent": true
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "corporateavailabledates": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "bookCalInfos": [
        {
          "bookCnt": "27",
          "bookDate": "20250715",
          "bookTimes": [
            "0730",
            "0745",
            "0800"
          ]
        },
        {
          "bookCnt": "22",
          "bookDate": "20250716",
          "bookTimes": [
            "0730",
            "0745",
            "0800"
          ]
        },
        {
          "bookCnt": "1",
          "bookDate": "20250717",
          "bookTimes": [
            "0730",
            "0745",
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250718",
          "bookTimes": [
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250719",
          "bookTimes": [
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250720",
          "bookTimes": [
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "10",
          "bookDate": "20250721",
          "bookTimes": [
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "2",
          "bookDate": "20250722",
          "bookTimes": [
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "2",
          "bookDate": "20250723",
          "bookTimes": [
            "0800",
            "1400"
          ]
        },
        {
          "bookCnt": "12",
          "bookDate": "20250724",
          "bookTimes": [
            "0800",
            "1400"
          ]
        }
      ],
      "nutCalInfos": [
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250715",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250716",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250717",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250718",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250719",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250720",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250721",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 1,
          "nutBookDate": "20250722",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 2,
          "nutBookDate": "20250723",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250724",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 10,
          "nutBookDate": "20250725",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        },
        {
          "nutBookCnt": 7,
          "nutBookDate": "20250726",
          "nutBookTimes": [
            "0900",
            "1000",
            "1100"
          ]
        }
      ],
      "imageCalInfos": true
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "corporateappointments": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "caseNo": "C20250427001"
    },
    "timestamp": "2025-05-13T13:10:00Z"
  },
  "allreports": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "hcreportList": [
        {
          "caseNo": "201234567",
          "bookDate": "20250701",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250630",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250629",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250628",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250627",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250626",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250625",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250624",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250623",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234567",
          "bookDate": "20250622",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250621",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250620",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250619",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250618",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250617",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250616",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250615",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250614",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234567",
          "bookDate": "20250613",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250612",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250611",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250610",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250609",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250608",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250607",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250606",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250605",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234567",
          "bookDate": "20250604",
          "bookStatus": "0"
        },
        {
          "caseNo": "123456789",
          "bookDate": "20250603",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456780",
          "bookDate": "20250602",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234568",
          "bookDate": "20250601",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456781",
          "bookDate": "20250531",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456782",
          "bookDate": "20250530",
          "bookStatus": "1"
        },
        {
          "caseNo": "201234563",
          "bookDate": "20250529",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456784",
          "bookDate": "20250528",
          "bookStatus": "1"
        },
        {
          "caseNo": "123456785",
          "bookDate": "20250527",
          "bookStatus": "1"
        }
      ]
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "name": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "name": "王小小"
    },
    "timestamp": "2025-05-28T13:40:00Z"
  },
  "phone": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "cell": "0912345678"
    },
    "timestamp": "2025-05-28T13:40:00Z"
  },
  "email": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "email": "test@email.com"
    },
    "timestamp": "2025-05-28T13:40:00Z"
  },
  "verifycurrentpassword": {
    "success": true,
    "statusCode": "S0000",
    "data": {},
    "timestamp": "2025-04-27T13:40:00Z"
  },
  "changepassword": {
    "success": true,
    "statusCode": "S0000",
    "data": {},
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "appointmenthistory": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "flowCode": "0"
    },
    "timestamp": "2025-04-27T13:00:00Z"
  },
  "plans": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "dataType": "1",
      "isModified": true,
      "isCancel": true,
      "reminders": [
        {
          "date": "2025/04/01",
          "description": [
            "開始每日攝取足夠的水分，至少1,500~2,000c.c."
          ]
        },
        {
          "date": "2025/04/18",
          "description": [
            "服用清腸藥之前可留取糞便檢體，檢體放冰箱冷藏，冷藏不超過2天",
            "女性若遇生理期，請勿留取檢體"
          ]
        },
        {
          "date": "2025/04/21",
          "description": [
            "檢查前需空腹至少8小時，女性收集檢體與當日檢查請避開生理期間，若遇生理期，可前往健檢、或於預約紀錄修改健檢日期",
            "報到時請主動告知是否懷孕或備孕，過敏史及用藥情況",
            "報到請準備：<br/>a. 健保卡／身分證或居留證<br/>b. 已完成資料袋內之文件"
          ]
        }
      ],
      "reminderGroups": [
        {
          "groupId": "GI05",
          "groupName": "內視鏡檢後提醒",
          "examItem": "LB0002000M",
          "examName": "無痛AI胃腸鏡",
          "reminderInfos": [
            {
              "reminderId": "085",
              "reminderName": "已知檢查當日若有息肉切除，為避免出血，健檢完兩週內不可搭乘飛機"
            },
            {
              "reminderId": "086",
              "reminderName": "已知檢查當日若有息肉切片，為避免出血，健檢完三天內不可搭乘飛機"
            }
          ]
        },
        {
          "groupId": "GI08",
          "groupName": "眼底斷層掃描檢前提醒",
          "examItem": "LB0007000M",
          "examName": "眼底斷層掃描",
          "reminderInfos": [
            {
              "reminderId": "101",
              "reminderName": "檢查前請勿配戴隱形眼鏡，並攜帶眼鏡以備檢查後使用"
            },
            {
              "reminderId": "102",
              "reminderName": "檢查後短暫視力模糊屬正常現象，請勿自行駕車"
            }
          ]
        }
      ],
      "bookingInfo": {
        "checkupDate": {
          "bookDate": "20250601",
          "bookTime": "0900"
        },
        "nutrition": {
          "bookDate": "20250601",
          "bookTime": "1100"
        },
        "imaging": {
          "bookDate": "20250601",
          "bookTime": "1300"
        },
        "imagingContact": "0912345678",
        "orgName": "敦南中心",
        "orgAddress": "台北市大安區敦化南路二段333號2樓",
        "contactAddress": "台北市大安區光復南路102號13F",
        "deliveryMethod": "01",
        "deliveryAddress": "台北市大安區光復南路102號13F",
        "language": "中文",
        "clothesSize": "L",
        "breakfast": "中式/素食",
        "lunch": "中式/素食"
      },
      "packageGroup": {
        "selfAmt": "18500",
        "dayType": "2",
        "packageName": "全方位健檢",
        "packageDetail": {
          "packageList": [
            {
              "deptName": "一般檢查",
              "deptEName": "General Examination",
              "examInfo": [
                {
                  "examName": "身體組成分析",
                  "examItem": "PE00010040"
                },
                {
                  "examName": "身高",
                  "examItem": "PE00010001"
                },
                {
                  "examName": "體重",
                  "examItem": "PE00010002"
                },
                {
                  "examName": "身體質量指數",
                  "examItem": "PE00010006"
                },
                {
                  "examName": "理想體重",
                  "examItem": "PE00010003"
                },
                {
                  "examName": "脈搏",
                  "examItem": "PE00010007A"
                },
                {
                  "examName": "血壓",
                  "examItem": "PE00010009A"
                },
                {
                  "examName": "腰圍",
                  "examItem": "PE00010017"
                }
              ]
            },
            {
              "deptName": "心血管及代謝系統",
              "deptEName": "Cardiovascular and Metabolic System",
              "examInfo": [
                {
                  "examName": "總膽固醇",
                  "examItem": "L3001900"
                },
                {
                  "examName": "三酸甘油脂",
                  "examItem": "L3002000"
                }
              ]
            },
            {
              "deptName": "腫瘤標記",
              "deptEName": "Tumor Marker",
              "examInfo": [
                {
                  "examName": "癌胚胎抗原",
                  "examItem": "LI001600"
                },
                {
                  "examName": "鱗狀細胞癌抗原",
                  "examItem": "LI005200"
                }
              ]
            }
          ],
          "addList": [
            {
              "examItem": "PE000001A",
              "examName": "眼底斷層掃描"
            },
            {
              "examItem": "R401470005",
              "examName": "十年心血管疾病風險評估"
            },
            {
              "examItem": "PE00010006",
              "examName": "身體質量指數"
            }
          ]
        }
      }
    },
    "timestamp": "2025-06-02T13:00:00Z"
  },
  "cancelappointmentinfo": {
    "success": true,
    "statusCode": "S0000",
    "data": {},
    "timestamp": "2025-04-27T13:40:00Z"
  },
  "healthForm": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "questionnaireId": 20,
      "entQuestionnaireId": 681,
      "questionnaireName": "健康調查表",
      "formId": "S00006",
      "formItemList": [
        {
          "itemId": "I000000051",
          "description": "健康調查表",
          "isSelected": "Y"
        }
      ],
      "questionList": [
        {
          "sortNo": 1,
          "questionId": 472,
          "questionName": "自覺症狀",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1510",
              "choiceName": "以下皆無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1511",
              "choiceName": "頭暈",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1512",
              "choiceName": "頭痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1513",
              "choiceName": "視力模糊",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1514",
              "choiceName": "耳鳴",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1515",
              "choiceName": "咳嗽",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1516",
              "choiceName": "咳痰",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1517",
              "choiceName": "牙齦出血",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1518",
              "choiceName": "呼吸困難",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 10,
              "choiceId": "1519",
              "choiceName": "胸痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 11,
              "choiceId": "1520",
              "choiceName": "心悸",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 12,
              "choiceId": "1521",
              "choiceName": "腹痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 13,
              "choiceId": "1522",
              "choiceName": "胃灼熱",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 14,
              "choiceId": "1523",
              "choiceName": "噁心",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 15,
              "choiceId": "1524",
              "choiceName": "黑便",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 16,
              "choiceId": "1525",
              "choiceName": "腹瀉",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 17,
              "choiceId": "1526",
              "choiceName": "便秘",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 18,
              "choiceId": "1527",
              "choiceName": "脹氣",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 19,
              "choiceId": "1528",
              "choiceName": "血便",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 20,
              "choiceId": "1529",
              "choiceName": "排尿不適",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 21,
              "choiceId": "1530",
              "choiceName": "多尿、頻尿",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 22,
              "choiceId": "1531",
              "choiceName": "上背痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 23,
              "choiceId": "1532",
              "choiceName": "下背痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 24,
              "choiceId": "1533",
              "choiceName": "關節疼痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 25,
              "choiceId": "1534",
              "choiceName": "手腳麻痛",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 26,
              "choiceId": "1535",
              "choiceName": "手腳肌肉無力",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 27,
              "choiceId": "1536",
              "choiceName": "倦怠",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 28,
              "choiceId": "1537",
              "choiceName": "體重減輕3公斤以上",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 29,
              "choiceId": "1538",
              "choiceName": "其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 2,
          "questionId": 473,
          "questionName": "請輸入您的症狀",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1539",
              "choiceName": "(如選擇29其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 3,
          "questionId": 474,
          "questionName": "既往病史",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1540",
              "choiceName": "以下皆無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1541",
              "choiceName": "高血壓",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1542",
              "choiceName": "糖尿病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1543",
              "choiceName": "高血脂",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1544",
              "choiceName": "心臟病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1545",
              "choiceName": "白內障",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1546",
              "choiceName": "青光眼",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1547",
              "choiceName": "黃斑部病變",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1548",
              "choiceName": "中風",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 10,
              "choiceId": "1549",
              "choiceName": "癲癇",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 11,
              "choiceId": "1550",
              "choiceName": "氣喘",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 12,
              "choiceId": "1551",
              "choiceName": "慢性氣管炎",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 13,
              "choiceId": "1552",
              "choiceName": "肺氣腫",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 14,
              "choiceId": "1553",
              "choiceName": "肺結核",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 15,
              "choiceId": "1554",
              "choiceName": "肝病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 16,
              "choiceId": "1555",
              "choiceName": "脂肪肝",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 17,
              "choiceId": "1556",
              "choiceName": "貧血",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 18,
              "choiceId": "1557",
              "choiceName": "中耳炎",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 19,
              "choiceId": "1558",
              "choiceName": "聽力障礙",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 20,
              "choiceId": "1559",
              "choiceName": "甲狀腺疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 21,
              "choiceId": "1560",
              "choiceName": "逆流性食道炎",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 22,
              "choiceId": "1561",
              "choiceName": "消化性潰瘍",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 23,
              "choiceId": "1562",
              "choiceName": "胃炎",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 24,
              "choiceId": "1563",
              "choiceName": "過敏",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 25,
              "choiceId": "1564",
              "choiceName": "骨折",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 26,
              "choiceId": "1565",
              "choiceName": "癌症",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 27,
              "choiceId": "1566",
              "choiceName": "其他慢性疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 28,
              "choiceId": "1567",
              "choiceName": "其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 4,
          "questionId": 475,
          "questionName": "請輸入您的骨折部位",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1568",
              "choiceName": "(如選擇骨折為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 5,
          "questionId": 476,
          "questionName": "請輸入您的癌症部位",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1569",
              "choiceName": "(如選擇癌症為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 6,
          "questionId": 477,
          "questionName": "請輸入您的其他慢性病",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1570",
              "choiceName": "(如選擇其他慢性疾病為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 7,
          "questionId": 478,
          "questionName": "請輸入您的其他病史",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1571",
              "choiceName": "(如選擇其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 8,
          "questionId": 479,
          "questionName": "手術史或重大外傷",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1572",
              "choiceName": "無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1573",
              "choiceName": "有",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 9,
          "questionId": 480,
          "questionName": "請輸入您的手術史或重大外傷",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1574",
              "choiceName": "(如選擇有為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 10,
          "questionId": 481,
          "questionName": "長期服用藥物",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1575",
              "choiceName": "以下皆無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1576",
              "choiceName": "高血壓藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1577",
              "choiceName": "高血脂藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1578",
              "choiceName": "抗凝血劑",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1579",
              "choiceName": "心臟病藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1580",
              "choiceName": "糖尿病藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1581",
              "choiceName": "腸胃藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1582",
              "choiceName": "甲狀腺藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1583",
              "choiceName": "荷爾蒙藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 10,
              "choiceId": "1584",
              "choiceName": "助眠藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 11,
              "choiceId": "1585",
              "choiceName": "止痛藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 12,
              "choiceId": "1586",
              "choiceName": "氣喘藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 13,
              "choiceId": "1587",
              "choiceName": "尿酸藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 14,
              "choiceId": "1588",
              "choiceName": "類固醇藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 15,
              "choiceId": "1589",
              "choiceName": "中藥",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 16,
              "choiceId": "1590",
              "choiceName": "其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 11,
          "questionId": 482,
          "questionName": "請輸入您的長期服用藥物",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1591",
              "choiceName": "(如選擇16其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 12,
          "questionId": 483,
          "questionName": "家族病史",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1592",
              "choiceName": "以下皆無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1593",
              "choiceName": "高血壓",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1594",
              "choiceName": "高血脂",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1595",
              "choiceName": "糖尿病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1596",
              "choiceName": "心血管疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1597",
              "choiceName": "腦血管疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1598",
              "choiceName": "貧血",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1599",
              "choiceName": "慢性肝炎或肝硬化",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1600",
              "choiceName": "腎臟疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 10,
              "choiceId": "1601",
              "choiceName": "甲狀腺疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 11,
              "choiceId": "1602",
              "choiceName": "自體免疫疾病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 12,
              "choiceId": "1603",
              "choiceName": "白血病",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 13,
              "choiceId": "1604",
              "choiceName": "乳癌",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 14,
              "choiceId": "1605",
              "choiceName": "肺癌",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 15,
              "choiceId": "1606",
              "choiceName": "胰臟癌",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 16,
              "choiceId": "1607",
              "choiceName": "胃∕大腸癌",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 17,
              "choiceId": "1608",
              "choiceName": "卵巢∕子宮癌",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 18,
              "choiceId": "1609",
              "choiceName": "失智症",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 19,
              "choiceId": "1610",
              "choiceName": "其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 13,
          "questionId": 484,
          "questionName": "請輸入您的家族病史",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1611",
              "choiceName": "(如選擇19其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 14,
          "questionId": 485,
          "questionName": "最近六個月內是否有嚼食檳榔",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1612",
              "choiceName": "從未嚼食檳榔",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1613",
              "choiceName": "偶爾嚼(不是天天)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1614",
              "choiceName": "(幾乎)每天嚼",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1615",
              "choiceName": "已經戒食",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 15,
          "questionId": 486,
          "questionName": "平均每天嚼___顆",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1616",
              "choiceName": "(如選擇(幾乎)每天嚼為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 16,
          "questionId": 487,
          "questionName": "已嚼___年",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1617",
              "choiceName": "(如選擇(幾乎)每天嚼為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 17,
          "questionId": 488,
          "questionName": "已經戒食，戒了___年",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1618",
              "choiceName": "(如選擇已經戒食為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 18,
          "questionId": 489,
          "questionName": "___月",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1619",
              "choiceName": "(如選擇已經戒食為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 19,
          "questionId": 490,
          "questionName": "過去一個月內是否有吸菸",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1620",
              "choiceName": "從未吸菸",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1621",
              "choiceName": "偶爾(不是天天)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1622",
              "choiceName": "(幾乎)每天吸",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1623",
              "choiceName": "已經戒菸",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 20,
          "questionId": 491,
          "questionName": "平均每天吸___支",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1624",
              "choiceName": "(如選擇(幾乎)每天吸為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 21,
          "questionId": 492,
          "questionName": "已吸___年",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1625",
              "choiceName": "(如選擇(幾乎)每天吸為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 22,
          "questionId": 493,
          "questionName": "已經戒菸，戒了___年",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1626",
              "choiceName": "(如選擇已經戒菸為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 23,
          "questionId": 494,
          "questionName": "___月",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1627",
              "choiceName": "(如選擇已經戒菸為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 24,
          "questionId": 495,
          "questionName": "過去一個月內是否有喝酒",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1628",
              "choiceName": "從未喝酒",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1629",
              "choiceName": "偶爾(不是天天)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1630",
              "choiceName": "(幾乎)每天喝",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1631",
              "choiceName": "已經戒酒",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 25,
          "questionId": 496,
          "questionName": "平均每週喝___次",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1632",
              "choiceName": "(如選擇(幾乎)每天喝為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 26,
          "questionId": 497,
          "questionName": "最常喝___酒",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1633",
              "choiceName": "(如選擇(幾乎)每天喝為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 27,
          "questionId": 498,
          "questionName": "每次___CC",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1634",
              "choiceName": "(如選擇(幾乎)每天喝為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 28,
          "questionId": 499,
          "questionName": "已經戒酒，戒了___年",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1635",
              "choiceName": "(如選擇已經戒酒為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 29,
          "questionId": 500,
          "questionName": "___月",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1636",
              "choiceName": "(如選擇已經戒酒為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 30,
          "questionId": 501,
          "questionName": "飲食習慣(可複選)",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1637",
              "choiceName": "以下皆無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1638",
              "choiceName": "全素食",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1639",
              "choiceName": "嗜甜/手搖飲",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1640",
              "choiceName": "嗜糕點/麵包",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1641",
              "choiceName": "嗜肥肉/油炸",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1642",
              "choiceName": "每天至少1杯咖啡",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 31,
          "questionId": 502,
          "questionName": "1.運動習慣",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1643",
              "choiceName": "無(接續填答2-5)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1644",
              "choiceName": "有(接續填答5-9)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 32,
          "questionId": 503,
          "questionName": "2.能夠舒適走多久",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1645",
              "choiceName": "10分鐘以下",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1646",
              "choiceName": "11~30分鐘",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1647",
              "choiceName": "31分鐘以上",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 33,
          "questionId": 504,
          "questionName": "3.能夠提重物或做伏地挺身",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1648",
              "choiceName": "不行",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1649",
              "choiceName": "可以",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 34,
          "questionId": 505,
          "questionName": "4.運動喜好(可複選)",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1650",
              "choiceName": "健行或跑步",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1651",
              "choiceName": "自行車",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1652",
              "choiceName": "游泳",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1653",
              "choiceName": "舞蹈和有氧體操",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1654",
              "choiceName": "球類運動",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 35,
          "questionId": 506,
          "questionName": "5.運動禁忌(可複選)",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1655",
              "choiceName": "無",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1656",
              "choiceName": "上肢",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1657",
              "choiceName": "脊椎、背部",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1658",
              "choiceName": "下肢",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 36,
          "questionId": 507,
          "questionName": "6.通常進行哪種運動(可複選)",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1659",
              "choiceName": "健行或跑步",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1660",
              "choiceName": "自行車",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1661",
              "choiceName": "游泳",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1662",
              "choiceName": "舞蹈和有氧體操",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1663",
              "choiceName": "球類運動",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1664",
              "choiceName": "重量訓練",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 37,
          "questionId": 508,
          "questionName": "7.每周運動時間",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1665",
              "choiceName": "30分鐘以下",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1666",
              "choiceName": "31~60分鐘",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1667",
              "choiceName": "61分鐘以上",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 38,
          "questionId": 509,
          "questionName": "8.每次運動時間",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1668",
              "choiceName": "15分鐘以下",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1669",
              "choiceName": "16~60分鐘",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1670",
              "choiceName": "61分鐘以上",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 39,
          "questionId": 510,
          "questionName": "9.運動強度",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1671",
              "choiceName": "輕度 (運動中可輕鬆講話)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1672",
              "choiceName": "中度 (運動中講話有點喘)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1673",
              "choiceName": "高度 (運動中無法講話)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 40,
          "questionId": 511,
          "questionName": "常住國家(可複選)",
          "description": "",
          "questionType": "4",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1674",
              "choiceName": "中華民國",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1675",
              "choiceName": "中國(港澳)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1676",
              "choiceName": "日韓",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1677",
              "choiceName": "美加",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1678",
              "choiceName": "歐洲",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1679",
              "choiceName": "其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 41,
          "questionId": 512,
          "questionName": "常住國家其他",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1680",
              "choiceName": "(如選擇6其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 42,
          "questionId": 513,
          "questionName": "婚姻狀況",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1681",
              "choiceName": "未婚",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1682",
              "choiceName": "已婚",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1683",
              "choiceName": "鰥寡",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1684",
              "choiceName": "離婚",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 43,
          "questionId": 514,
          "questionName": "教育程度",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1685",
              "choiceName": "國中(含)以下",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1686",
              "choiceName": "高中",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1687",
              "choiceName": "專科",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1688",
              "choiceName": "大學",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1689",
              "choiceName": "研究所以上",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 44,
          "questionId": 515,
          "questionName": "職位",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1690",
              "choiceName": "負責人",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1691",
              "choiceName": "高階主管",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1692",
              "choiceName": "中階主管",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1693",
              "choiceName": "基層主管",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1694",
              "choiceName": "內勤事務",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1695",
              "choiceName": "外務",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1696",
              "choiceName": "專業人員",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1697",
              "choiceName": "技術人員",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1698",
              "choiceName": "其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 45,
          "questionId": 516,
          "questionName": "職位其他",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1699",
              "choiceName": "(如選擇其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 46,
          "questionId": 517,
          "questionName": "客戶姓名",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1700",
              "choiceName": "",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 47,
          "questionId": 518,
          "questionName": "受僱日期",
          "description": "",
          "questionType": "7",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1701",
              "choiceName": "YYYY/MM/DD",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 48,
          "questionId": 519,
          "questionName": "曾經從事行業",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1702",
              "choiceName": "01 服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1703",
              "choiceName": "02 出版、影音製作、傳播及資通訊服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1704",
              "choiceName": "03 製造業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1705",
              "choiceName": "04 金融及保險業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1706",
              "choiceName": "05 營建工程業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1707",
              "choiceName": "06 批發及零售業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1708",
              "choiceName": "07 運輸及倉儲業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1709",
              "choiceName": "08 不動產業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1710",
              "choiceName": "09 住宿及餐飲業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 10,
              "choiceId": "1711",
              "choiceName": "10 農、林、漁、牧業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 11,
              "choiceId": "1712",
              "choiceName": "11 礦產及土石採取業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 12,
              "choiceId": "1713",
              "choiceName": "12 電力及燃氣供應業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 13,
              "choiceId": "1714",
              "choiceName": "13 用水供應及污染整治業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 14,
              "choiceId": "1715",
              "choiceName": "14 公共行政及國防；強制性社會安全",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 15,
              "choiceId": "1716",
              "choiceName": "15 教育業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 16,
              "choiceId": "1717",
              "choiceName": "16 專業、科學及技術服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 17,
              "choiceId": "1718",
              "choiceName": "17 醫療保健及社會工作服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 18,
              "choiceId": "1719",
              "choiceName": "18 藝術、娛樂及休閒服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 19,
              "choiceId": "1720",
              "choiceName": "19 其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 49,
          "questionId": 520,
          "questionName": "請填寫曾經從事行業",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1721",
              "choiceName": "(如選擇19其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 50,
          "questionId": 521,
          "questionName": "起始日期",
          "description": "",
          "questionType": "8",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1722",
              "choiceName": "YYYY/MM",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 51,
          "questionId": 522,
          "questionName": "截止日期",
          "description": "",
          "questionType": "8",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1723",
              "choiceName": "YYYY/MM",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 52,
          "questionId": 523,
          "questionName": "目前從事行業",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1724",
              "choiceName": "01 服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1725",
              "choiceName": "02 出版、影音製作、傳播及資通訊服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1726",
              "choiceName": "03 製造業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1727",
              "choiceName": "04 金融及保險業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "1728",
              "choiceName": "05 營建工程業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 6,
              "choiceId": "1729",
              "choiceName": "06 批發及零售業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 7,
              "choiceId": "1730",
              "choiceName": "07 運輸及倉儲業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 8,
              "choiceId": "1731",
              "choiceName": "08 不動產業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 9,
              "choiceId": "1732",
              "choiceName": "09 住宿及餐飲業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 10,
              "choiceId": "1733",
              "choiceName": "10 農、林、漁、牧業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 11,
              "choiceId": "1734",
              "choiceName": "11 礦產及土石採取業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 12,
              "choiceId": "1735",
              "choiceName": "12 電力及燃氣供應業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 13,
              "choiceId": "1736",
              "choiceName": "13 用水供應及污染整治業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 14,
              "choiceId": "1737",
              "choiceName": "14 公共行政及國防；強制性社會安全",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 15,
              "choiceId": "1738",
              "choiceName": "15 教育業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 16,
              "choiceId": "1739",
              "choiceName": "16 專業、科學及技術服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 17,
              "choiceId": "1740",
              "choiceName": "17 醫療保健及社會工作服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 18,
              "choiceId": "1741",
              "choiceName": "18 藝術、娛樂及休閒服務業",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 19,
              "choiceId": "1742",
              "choiceName": "19 其他",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 53,
          "questionId": 524,
          "questionName": "請填寫目前從事行業",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1743",
              "choiceName": "(如選擇19其他為必填)",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 54,
          "questionId": 525,
          "questionName": "起始日期",
          "description": "",
          "questionType": "8",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1744",
              "choiceName": "YYYY/MM",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 55,
          "questionId": 526,
          "questionName": "截止日期",
          "description": "",
          "questionType": "8",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1745",
              "choiceName": "YYYY/MM",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 56,
          "questionId": 527,
          "questionName": "是否需輪班",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1746",
              "choiceName": "否",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1747",
              "choiceName": "是",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 57,
          "questionId": 528,
          "questionName": "輪班制",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1748",
              "choiceName": "兩班制",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1749",
              "choiceName": "三班制",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "1750",
              "choiceName": "四班制",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "1751",
              "choiceName": "其它",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 58,
          "questionId": 529,
          "questionName": "請填寫輪班方式",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1752",
              "choiceName": "",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 59,
          "questionId": 530,
          "questionName": "過去一個月,平均每週工時(每週工作日×每日工時)",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1753",
              "choiceName": "請填寫整數",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 60,
          "questionId": 531,
          "questionName": "過去六個月,平均每週工時(每週工作日×每日工時)",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1754",
              "choiceName": "請填寫整數",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 61,
          "questionId": 532,
          "questionName": "檢查時期（原因）",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1755",
              "choiceName": "新進員工(受僱時)",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "1756",
              "choiceName": "定期檢查",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 62,
          "questionId": 533,
          "questionName": "工作日期間，平均每天睡眠時間",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "1757",
              "choiceName": "請填寫整數",
              "description": "",
              "choiceValue": ""
            }
          ]
        }
      ],
      "answerList": []
    },
    "timestamp": "2026-03-27T00:00:00Z"
  },
  "bonesForm": {
    "success": true,
    "statusCode": "S0000",
    "data": {
      "questionnaireId": 2,
      "entQuestionnaireId": 23,
      "questionnaireName": "肌肉骨骼症狀調查表",
      "formId": "",
      "formItemList": [],
      "questionList": [
        {
          "sortNo": 1,
          "questionId": 16,
          "questionName": "廠區",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "68",
              "choiceName": "請填寫",
              "description": "(此欄位必填)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 2,
          "questionId": 17,
          "questionName": "部門",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "69",
              "choiceName": "請填寫",
              "description": "(如無，請輸入未填寫)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 3,
          "questionId": 18,
          "questionName": "課/組",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "70",
              "choiceName": "請填寫",
              "description": "(如無，請輸入無)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 4,
          "questionId": 19,
          "questionName": "作業名稱",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "71",
              "choiceName": "請填寫",
              "description": "(如無，請輸入無)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 5,
          "questionId": 20,
          "questionName": "職稱",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "72",
              "choiceName": "請填寫",
              "description": "(如無，請輸入未填寫)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 6,
          "questionId": 21,
          "questionName": "勞工編號",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "73",
              "choiceName": "請填寫",
              "description": "(如無，請輸入無)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 7,
          "questionId": 22,
          "questionName": "客戶姓名",
          "description": "",
          "questionType": "1",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "74",
              "choiceName": "",
              "description": "(此欄位必填)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 8,
          "questionId": 23,
          "questionName": "性別",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "75",
              "choiceName": "男",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "76",
              "choiceName": "女",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 9,
          "questionId": 24,
          "questionName": "年齡",
          "description": "",
          "questionType": "10",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "77",
              "choiceName": "___歲",
              "description": "(此欄位必填)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 10,
          "questionId": 25,
          "questionName": "年資",
          "description": "",
          "questionType": "9",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "78",
              "choiceName": "___年",
              "description": "(此欄位必填)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 11,
          "questionId": 26,
          "questionName": "身高",
          "description": "",
          "questionType": "9",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "79",
              "choiceName": "___公分",
              "description": "(此欄位必填)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 12,
          "questionId": 27,
          "questionName": "體重",
          "description": "",
          "questionType": "9",
          "choiceList": [
            {
              "sortNo": 1,
              "choiceId": "80",
              "choiceName": "___公斤",
              "description": "(此欄位必填)",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 13,
          "questionId": 28,
          "questionName": "慣用手",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "81",
              "choiceName": "左手",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "82",
              "choiceName": "右手",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 14,
          "questionId": 29,
          "questionName": "一、您在過去的1年內，身體是否有長達兩星期以上的疲勞、痠痛、發麻、刺痛等不舒服，或關節活動受到限制?",
          "description": "（若否，結束此調查表；若是，請繼續填寫下列表格。）",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "83",
              "choiceName": "否",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "84",
              "choiceName": "是",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 15,
          "questionId": 30,
          "questionName": "二、下表的身體部位痠痛、不適或影響關節活動之情況持續多久時間？",
          "description": "",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "85",
              "choiceName": "1個月",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "86",
              "choiceName": "3個月",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "87",
              "choiceName": "6個月",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "88",
              "choiceName": "1年",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "89",
              "choiceName": "3年",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "90",
              "choiceName": "3年以上",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 16,
          "questionId": 31,
          "questionName": "頸",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "91",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "92",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "93",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "94",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "95",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "96",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 17,
          "questionId": 32,
          "questionName": "左肩",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "97",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "98",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "99",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "100",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "101",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "102",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 18,
          "questionId": 33,
          "questionName": "左手肘/左前臂",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "103",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "104",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "105",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "106",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "107",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "108",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 19,
          "questionId": 34,
          "questionName": "左手/左手腕",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "109",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "110",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "111",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "112",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "113",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "114",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 20,
          "questionId": 35,
          "questionName": "左臀/左大腿",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "115",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "116",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "117",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "118",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "119",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "120",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 21,
          "questionId": 36,
          "questionName": "左膝",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "121",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "122",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "123",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "124",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "125",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "126",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 22,
          "questionId": 37,
          "questionName": "左腳踝/左腳",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "127",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "128",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "129",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "130",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "131",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "132",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 23,
          "questionId": 38,
          "questionName": "上背",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "133",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "134",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "135",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "136",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "137",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "138",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 24,
          "questionId": 39,
          "questionName": "右肩",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "139",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "140",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "141",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "142",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "143",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "144",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 25,
          "questionId": 40,
          "questionName": "右手肘/右前臂",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "145",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "146",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "147",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "148",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "149",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "150",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 26,
          "questionId": 41,
          "questionName": "下背",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "151",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "152",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "153",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "154",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "155",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "156",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 27,
          "questionId": 42,
          "questionName": "右手/右手腕",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "157",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "158",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "159",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "160",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "161",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "162",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 28,
          "questionId": 43,
          "questionName": "右臀/右大腿",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "163",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "164",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "165",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "166",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "167",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "168",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 29,
          "questionId": 44,
          "questionName": "右膝",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "169",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "170",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "171",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "172",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "173",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "174",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 30,
          "questionId": 45,
          "questionName": "右腳踝/右腳",
          "description": "(0:不痛~5:極為劇痛，數字越大，痠痛程度越高)",
          "questionType": "3",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "175",
              "choiceName": "0",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 1,
              "choiceId": "176",
              "choiceName": "1",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 2,
              "choiceId": "177",
              "choiceName": "2",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 3,
              "choiceId": "178",
              "choiceName": "3",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 4,
              "choiceId": "179",
              "choiceName": "4",
              "description": "",
              "choiceValue": ""
            },
            {
              "sortNo": 5,
              "choiceId": "180",
              "choiceName": "5",
              "description": "",
              "choiceValue": ""
            }
          ]
        },
        {
          "sortNo": 31,
          "questionId": 46,
          "questionName": "四、其他症狀、病史說明",
          "description": "",
          "questionType": "2",
          "choiceList": [
            {
              "sortNo": 0,
              "choiceId": "181",
              "choiceName": "請輸入您的其他症況、病史",
              "description": "(如無，請輸入無)",
              "choiceValue": ""
            }
          ]
        }
      ],
      "answerList": []
    },
    "timestamp": "2026-03-31T00:00:00Z"
  }
}